//微信小程序
export const isWeiXin =
  window.navigator.userAgent.indexOf('MicroMessenger') > 0 &&
  window.__wxjs_environment === 'miniprogram'

//支付宝
export const isAliPay = window.navigator.userAgent.indexOf('AlipayClient') > 0

//广电安卓app
export const isAndroid = navigator.userAgent.indexOf('CBN') > -1 && navigator.userAgent.indexOf('CBN_IOS') < 0

//广电iosApp
export const isIos = navigator.userAgent.indexOf('CBN_IOS') > -1

//微信环境
export const isWeiXinA = window.navigator.userAgent.indexOf('MicroMessenger') > 0

// 获取当前最近半年日期
export const getRecentYearDateRange = () => {
  const myDate = new Date
  let year = myDate.getFullYear() //获取当前年
  let mon = myDate.getMonth() + 1 //获取当前月
  const day = myDate.getDate() //获取当前天
  const endTime = `${year}-${mon > 9 ? mon : `0${mon}`}-${day > 9 ? day : `0${day}`}`
  for (let i = 0; i < 11; i++) {
      if (mon - 1 < 1) {
          year = year - 1
          mon = 12
      } else {
          mon = mon - 1
      }
  }
  var beginTime = `${year}-${mon > 9 ? mon : `0${mon}`}-01`
  return { beginTime, endTime }
}

// 数字进度问题处理
export const mulFloatToInt = (arg1, arg2) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
